import Vue from "vue";
import { FORM_TYPE, BUILDER_TYPE } from "../constants/custom-define-type";
import { MAP_DIALOG_SECTION } from "../constants/field-types";
import { REGEX_EXTRACT_FIELD_TAGS, REGEX_EXTRACT_FIELD_SUB_TAGS } from "../constants/regex";

Vue.mixin({
  methods: {
    /*Get key of fields which is in title of an object
     For example:
     If the listField represent for a field of children, keyTitles will include first_name and last_name
     */
    getKeyTitles(listFields, initValue) {
      if (!listFields) {
        return [];
      }
      if (Array.isArray(initValue) && initValue.length > 0) {
        return initValue;
      }
      // Check if first_name and last_name are existed in listFields
      const hasFirstNameField = listFields.some(
        field => field.model === "first_name"
      );
      const hasLastNameField = listFields.some(
        field => field.model === "last_name"
      );
      const hasMiddleNameField = listFields.some(
        field => field.model === "middle_name"
      );
      if (hasFirstNameField && hasLastNameField) {
        if (hasMiddleNameField) {
          return ["first_name", "middle_name", "last_name"];
        } else {
          return ["first_name", "last_name"];
        }
      }
      // Check if title is existed in listFields (in case of experience dialog)
      const hasTitleField = listFields.some(field => field.model === "title");
      if (hasTitleField) {
        return ["title"];
      }

      // Check if name is existed in listFields (in case of reference dialog)
      const hasNameField = listFields.some(field => field.model === "name");
      if (hasNameField) {
        return ["name"];
      }

      // Check if institution_type is existed in listFelds (in case of education dialog)
      const hasInstitutionType = listFields.some(
        // field => field.model === "institution_type"
        field => field.model === "area_of_study"
      );
      if (hasInstitutionType) {
        // return ["institution_type"];
        return ["area_of_study"];
      }

      // Check if employer name is existed in listFields (in case of experience dialog)
      const hasEmployerName = listFields.some(field => field.model === "person_worked_for_name");
      if (hasEmployerName) {
        return ["person_worked_for_name"];
      }

      return [];
    },
    /*
    Merge multiple builders (by combine between multiple sections)
    For example: a builder for application form includes builders for 3 sections
    [{
        sectionBuilderId: 1,
        type: Dialog_Section,
        api: 'api1'
      },
      {
        sectionBuilderId: 2,
        type: Dialog_Section,
        api: 'api2'
      },
      {
        sectionBuilderId: 3,
        type: Dialog_Section,
        api: 'api3'
      }
    ],
    listBuilder contains detail information for each section Builder,
    [
      {
        id: 1,
        list_fields: [
          field1,
          field2
        ]
      },
      {
        id: 2,
        list_fields: [
          field3,
          field4
        ]
      },
      {
        id: 3,
        list_fields: [
          field5,
          field6
        ]
      },
    ]

    => Output:
    listRejectCondition: Combination of list reject condition of related builders (only with people API)
    listFields: [{
        sectionBuilderId: 1,
        type: Dialog_Section,
        api: 'api1',
        list_fields: [
          field1, field2
        ]
      },
      {
        sectionBuilderId: 2,
        type: Dialog_Section,
        api: 'api2',
        list_fields: [
          field3, field4
        ]
      },
      {
        sectionBuilderId: 3,
        type: Dialog_Section,
        api: 'api3',
        list_fields: [
          field5, field6
        ]
      }
    ]
    */
    mergeBuilders(inputMainBuilder, listBuilder, keepPeopleSection = false) {
      if (inputMainBuilder == null || inputMainBuilder.list_fields == null
        || listBuilder == null) {
        return { listFields: [] };
      }
      const mainBuilder = JSON.parse(JSON.stringify(inputMainBuilder));
      let listFieldsOutput = [];
      let listModelsPrivate = [];
      let listModelsAdminClient = [];
      let listModelsAdminOnly = [];
      const listConditionKeys = this.$store.getters.listBuilderConditionKeys;
      const mapListConditions = {}
      listConditionKeys.forEach(item => {
        mapListConditions[item.varKey] = [];
        if (mainBuilder[item.apiKey] != null) {
          mapListConditions[item.varKey].push(mainBuilder[item.apiKey]);
        }
      });
      if (mainBuilder.list_models_private != null) {
        listModelsPrivate.push(mainBuilder.list_models_private);
      }
      if (mainBuilder.admin_and_client_only != null) {
        listModelsAdminClient.push(mainBuilder.admin_and_client_only);
      }
      if (mainBuilder.admin_only != null) {
        listModelsAdminOnly.push(mainBuilder.admin_only);
      }
      mainBuilder.list_fields.forEach((field, index) => {
        if (field.type === FORM_TYPE.SECTION) {
          let sectionBuilder = listBuilder.find(
            builder => builder.id === field.sectionBuilderId
          );
          if (sectionBuilder == null) {
            return;
          }
          // Clone sectionBuilder to avoid modifying its property
          try {
            sectionBuilder = JSON.parse(JSON.stringify(sectionBuilder));
          } catch (e) {

          }
          sectionBuilder.list_fields.forEach((field, sectionFieldIndex) => {
            // Add validation for email field
            if (field.model && ["email", "email2"].includes(field.model.toLowerCase())) {
              field.validation = [
                {
                  regex: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/,
                  message: "Please enter a valid email."
                }
              ];
            }
          });
          // Check if it is people API
          if (sectionBuilder.api === MAP_DIALOG_SECTION.People.api) {
            if (keepPeopleSection && !field.hideSectionTitle) {
              // In case of other API (reference, children, experience, ...)
              field.list_fields = sectionBuilder.list_fields;
              // Find corresponding section type
              field.name = "People";
              field.status = sectionBuilder.status_change;
              field.visibleBeyondStatus = sectionBuilder.visible_beyond_status;
              field.noEditStatus = sectionBuilder.no_edit_status;
              field.hideFromOwnerStatus = sectionBuilder.hide_from_owner_status;
              field.listVisibleStatuses = sectionBuilder.visible_statuses;
              field.listVisibleTypes = sectionBuilder.visible_types;
              field.submissionNotification =
                sectionBuilder.submission_notification;
              field.submissionNotificationEmails =
                sectionBuilder.submission_notification_emails;
              field.submissionNotificationEmails2 =
                sectionBuilder.submission_notification_emails2;
              field.submissionConfirmation =
                sectionBuilder.submission_confirmation;
              field.rejectionMessage = sectionBuilder.rejection_message;
              listConditionKeys.forEach(item => {
                field[item.varKey] = sectionBuilder[item.apiKey];
              });
              field.listModelsPrivate = sectionBuilder.list_models_private;
              field.listModelsAdminClient = sectionBuilder.admin_and_client_only;
              field.listModelsAdminOnly = sectionBuilder.admin_only;
              if (field.isPrivate == null) {
                field.isPrivate = sectionBuilder.is_private;
              }
              field.additionalInformation = sectionBuilder.additional_information;
              field.scrollToSectionId = sectionBuilder.scroll_to_section_id;
              field.backgroundColor = sectionBuilder.background_color;
              field.id = sectionBuilder.id;
              listFieldsOutput.push(field);
            } else {
              const stepIndex = field.stepIndex;
              const isPreconditionCheck = field.isPreconditionCheck;
              const rejectionMessage = field.rejectionMessage;
              // Insert header
              if (!field.hideSectionTitle) {
                const headerField = {
                  type: FORM_TYPE.HEADER,
                  label: field.label ? field.label : sectionBuilder.name,
                  description: field.description,
                  adminDescription: field.adminDescription,
                  visibleBeyondStatus: sectionBuilder.visible_beyond_status,
                  noEditStatus: sectionBuilder.no_edit_status,
                  hideFromOwnerStatus: sectionBuilder.hide_from_owner_status,
                  listVisibleStatuses: sectionBuilder.visible_statuses,
                  listVisibleTypes: sectionBuilder.visible_types,
                  stepIndex: stepIndex,
                  isPreconditionCheck: isPreconditionCheck,
                  rejectionMessage: rejectionMessage,
                  builderId: sectionBuilder.id
                };
                // Copy multi-languages label, description, admin description
                for (const key of Object.keys(field)) {
                  if (key.includes('_lang_')) {
                    headerField[key] = field[key];
                  }
                }
                // Add show if and show if condition of parent field to sub list_fields
                if (field.showIf) {
                  headerField.showIfContainer = field.showIf;
                  if (field.showIfValue) {
                    headerField.showIfValueContainer = field.showIfValue;
                  }
                  if (field.showIfEmpty) {
                    headerField.showIfEmptyContainer = field.showIfEmpty;
                  }
                }
                // Secondary show condition of container
                if (field.showIfSecondary) {
                  headerField.showIfSecondaryContainer = field.showIfSecondary;
                  if (field.showIfValueSecondary) {
                    headerField.showIfValueSecondaryContainer = field.showIfValueSecondary;
                  }
                  if (field.showIfEmptySecondary) {
                    headerField.showIfEmptySecondaryContainer = field.showIfEmptySecondary;
                  }
                }
                // Third show condition of container
                if (field.showIfThird) {
                  headerField.showIfThirdContainer = field.showIfThird;
                  if (field.showIfValueThird) {
                    headerField.showIfValueThirdContainer = field.showIfValueThird;
                  }
                  if (field.showIfEmptyThird) {
                    headerField.showIfEmptyThirdContainer = field.showIfEmptyThird;
                  }
                }
                // Combined show condition of container
                if (field.combinedShowCondition) {
                  headerField.combinedShowConditionContainer = field.combinedShowCondition;
                }
                listFieldsOutput.push(headerField);
              }
              sectionBuilder.list_fields.forEach(field => {
                field.visibleBeyondStatus =
                  sectionBuilder.visible_beyond_status;
                field.noEditStatus =
                  sectionBuilder.no_edit_status;
                field.hideFromOwnerStatus =
                  sectionBuilder.hide_from_owner_status;
                field.listVisibleStatuses = sectionBuilder.visible_statuses;
                field.listVisibleTypes = sectionBuilder.visible_types;
                field.stepIndex = stepIndex;
                field.isPreconditionCheck = isPreconditionCheck;
                field.rejectionMessage = rejectionMessage;
                field.additionalInformation = sectionBuilder.additional_information;
                field.sectionBuilderName = sectionBuilder.name;
              });
              // Add show if and show if condition of parent field to sub list_fields
              if (field.showIf) {
                sectionBuilder.list_fields.forEach(subField => {
                  subField.showIfContainer = field.showIf;
                  if (field.showIfValue) {
                    subField.showIfValueContainer = field.showIfValue;
                  }
                  if (field.showIfEmpty) {
                    subField.showIfEmptyContainer = field.showIfEmpty;
                  }
                });
              }
              if (field.showIfSecondary) {
                sectionBuilder.list_fields.forEach(subField => {
                  subField.showIfSecondaryContainer = field.showIfSecondary;
                  if (field.showIfValueSecondary) {
                    subField.showIfValueSecondaryContainer = field.showIfValueSecondary;
                  }
                  if (field.showIfEmptySecondary) {
                    subField.showIfEmptySecondaryContainer = field.showIfEmptySecondary;
                  }
                });
              }
              if (field.showIfThird) {
                sectionBuilder.list_fields.forEach(subField => {
                  subField.showIfThirdContainer = field.showIfThird;
                  if (field.showIfValueThird) {
                    subField.showIfValueThirdContainer = field.showIfValueThird;
                  }
                  if (field.showIfEmptyThird) {
                    subField.showIfEmptyThirdContainer = field.showIfEmptyThird;
                  }
                });
              }
              if (field.combinedShowCondition) {
                sectionBuilder.list_fields.forEach(subField => {
                  subField.combinedShowConditionContainer = field.combinedShowCondition;
                });
              }
              listFieldsOutput = listFieldsOutput.concat(
                sectionBuilder.list_fields
              );
              listConditionKeys.forEach(item => {
                if (sectionBuilder[item.apiKey] != null) {
                  mapListConditions[item.varKey].push({ ...sectionBuilder[item.apiKey], id: sectionBuilder.id });
                }
              });
              if (sectionBuilder.list_models_private != null) {
                listModelsPrivate.push(sectionBuilder.list_models_private);
              }
              if (sectionBuilder.is_private && sectionBuilder.list_fields) {
                sectionBuilder.list_fields.forEach(field => field.isInPrivateSection = true);
              }
              if (sectionBuilder.admin_and_client_only != null) {
                listModelsAdminClient.push(sectionBuilder.admin_and_client_only);
              }
              if (sectionBuilder.admin_only != null) {
                listModelsAdminOnly.push(sectionBuilder.admin_only);
              }
            }
          } else {
            // In case of other API (reference, children, experience, ...)
            field.list_fields = sectionBuilder.list_fields;
            // Find corresponding section type
            field.name = Object.values(MAP_DIALOG_SECTION).find(
              item => item.api === sectionBuilder.api
            ).name;
            field.status = sectionBuilder.status_change;
            field.minCount = sectionBuilder.minimum_number_of_items;
            field.visibleBeyondStatus = sectionBuilder.visible_beyond_status;
            field.noEditStatus = sectionBuilder.no_edit_status;
            field.hideFromOwnerStatus = sectionBuilder.hide_from_owner_status;
            field.listVisibleStatuses = sectionBuilder.visible_statuses;
            field.listVisibleTypes = sectionBuilder.visible_types;
            field.submissionNotification =
              sectionBuilder.submission_notification;
            field.submissionNotificationEmails =
              sectionBuilder.submission_notification_emails;
            field.submissionNotificationEmails2 =
              sectionBuilder.submission_notification_emails2;
            field.submissionConfirmation =
              sectionBuilder.submission_confirmation;
            field.rejectionMessage = sectionBuilder.rejection_message;
            listConditionKeys.forEach(item => {
              field[item.varKey] = sectionBuilder[item.apiKey];
            });
            field.listModelsPrivate = sectionBuilder.list_models_private;
            field.listModelsAdminClient = sectionBuilder.admin_and_client_only;
            field.listModelsAdminOnly = sectionBuilder.admin_only;
            field.isPrivate = sectionBuilder.is_private;
            field.additionalInformation = sectionBuilder.additional_information;
            field.validation = sectionBuilder.validation;
            field.scrollToSectionId = sectionBuilder.scroll_to_section_id;
            field.backgroundColor = sectionBuilder.background_color;
            field.titleModels = sectionBuilder.title_models;
            // Add reference check form builder (if any)
            if (field.referenceCheckFormId) {
              const referenceCheckFormBuilder = listBuilder.find(builder => builder.id === field.referenceCheckFormId);
              if (referenceCheckFormBuilder) {
                field.listFieldCheckForm = referenceCheckFormBuilder.list_fields;
                field.isPrivateCheckForm = referenceCheckFormBuilder.is_private;
                field.additionalInfoCheckForm = referenceCheckFormBuilder.additional_information;
              }
            }
            listFieldsOutput.push(field);
          }
        } else if (field.type === FORM_TYPE.BOOKING_SECTION) {
          const sectionBuilder = listBuilder.find(
            builder => builder.id === field.sectionBuilderId
          );
          if (sectionBuilder) {
            // In case of booking section
            field.list_fields = sectionBuilder.list_fields;
            // Find corresponding section type
            field.name = Object.values(MAP_DIALOG_SECTION).find(
              item => item.api === sectionBuilder.api
            ).name;
            field.status = sectionBuilder.status_change;
            field.minCount = sectionBuilder.minimum_number_of_items;
            field.visibleBeyondStatus = sectionBuilder.visible_beyond_status;
            field.noEditStatus = sectionBuilder.no_edit_status;
            field.hideFromOwnerStatus = sectionBuilder.hide_from_owner_status;
            field.listVisibleStatuses = sectionBuilder.visible_statuses;
            field.listVisibleTypes = sectionBuilder.visible_types;
            field.submissionNotification =
              sectionBuilder.submission_notification;
            field.submissionNotificationEmails =
              sectionBuilder.submission_notification_emails;
            field.submissionNotificationEmails2 =
              sectionBuilder.submission_notification_emails2;
            field.submissionConfirmation =
              sectionBuilder.submission_confirmation;
            field.rejectionMessage = sectionBuilder.rejection_message;
            listConditionKeys.forEach(item => {
              field[item.varKey] = sectionBuilder[item.apiKey];
            });
            field.listModelsPrivate = sectionBuilder.list_models_private;
            field.listModelsAdminClient = sectionBuilder.admin_and_client_only;
            field.listModelsAdminOnly = sectionBuilder.admin_only;
            field.isPrivate = sectionBuilder.is_private;
            field.additionalInformation = sectionBuilder.additional_information;
            field.validation = sectionBuilder.validation;
            field.scrollToSectionId = sectionBuilder.scroll_to_section_id;
            field.backgroundColor = sectionBuilder.background_color;
            listFieldsOutput.push(field);
          }
        } else {
          if (field.model && mainBuilder.id) {
            field.builderId = mainBuilder.id;
          }
          // Add validation for email field
          if (field.model && ["email", "email2"].includes(field.model.toLowerCase())) {
            field.validation = [
              {
                regex: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/,
                message: "Please enter a valid email."
              }
            ];
          }
          listFieldsOutput.push(field);
        }
      });

      // Add list Fields for file with additional info field
      listFieldsOutput.forEach(field => {
        if (field.type === FORM_TYPE.FILE_WITH_INFO) {
          const fileInfoBuilder = listBuilder.find(
            builder => builder.id === field.fileInfoBuilderId
          );
          if (fileInfoBuilder) {
            field.list_fields = fileInfoBuilder.list_fields;
            field.listModelsPrivate = fileInfoBuilder.list_models_private;
            field.listModelsAdminClient = fileInfoBuilder.admin_and_client_only;
            field.listModelsAdminOnly = fileInfoBuilder.admin_only;
          }
        }
      })
      return {
        listFields: listFieldsOutput,
        ...mapListConditions,
        listModelsPrivate: listModelsPrivate,
        listModelsAdminClient: listModelsAdminClient,
        listModelsAdminOnly: listModelsAdminOnly,
        locations: mainBuilder.locations,
        languages: mainBuilder.languages
      };
    },
    /*
    Based on a multi-line input string,
    get corresponding object for submission dialog with structure
    {
      title: first_line
      message: other_lines
    }
    If submissionString is not defined, defaultContent will be used
    */
    getSubmissionDialogContent(submissionString, defaultContent) {
      if (submissionString && submissionString.trim().length > 0) {
        return {
          innerHtml: submissionString
        }
      } else {
        return defaultContent;
      }
    },
    /* extract the email within parentheses */
    extractEmail(emailName) {
      let emailRegExp = /\(([^)]+)\)/;
      return emailRegExp.exec(emailName)[1];
    },
    // Get list fields corresponding with userType (Client or Candidate) based on listBuilders
    // Each builder contains list of fields. This function merge all fields of the corresponding builder
    // then remove the duplicate item
    // includeSection: Include reference, experience, children, ... section
    getListFieldsByUserType(listBuilders, userType, includeSection = false) {
      // Find profile builders corresponding with userType
      const listBuildersByUserType = listBuilders.filter(
        (builder) =>
          [BUILDER_TYPE.PROFILE, BUILDER_TYPE.APPLICATION].includes(
            builder.type
          ) && builder.user_type === userType
      );
      const listFields = [];
      const listModels = [];
      for (const profileBuilder of listBuildersByUserType) {
        const mergedBuilder = this.mergeBuilders(
          profileBuilder,
          listBuilders,
          false
        );
        for (const field of mergedBuilder.listFields) {
          if (field.type === FORM_TYPE.SECTION) {
            const sectionModel = `section-${field.label}`;
            // Avoid duplicate fields
            if (listModels.includes(sectionModel)) {
              continue;
            }
            listFields.push({
              ...field,
              model: sectionModel
            });
            listModels.push(sectionModel);
            continue;
          }
          if (!field.model) {
            continue;
          }
          // Exclude file with info fields
          if ([FORM_TYPE.FILE_WITH_INFO].includes(field.type)) {
            continue;
          }
          // Avoid duplicate fields
          if (listModels.includes(field.model)) {
            continue;
          }
          listFields.push(field);
          listModels.push(field.model);
        }
      }
      return listFields;
    },
    getListBookingFields() {
      // Find all section booking for builders
      const listBookingBuilders = this.$store.getters.profileBuilderList.filter(
        (builder) => builder.api === MAP_DIALOG_SECTION.Booking.api
      );
      let result = [];
      for (const bookingBuilder of listBookingBuilders) {
        if (bookingBuilder.list_fields) {
          result = [
            ...result,
            ...bookingBuilder.list_fields.filter((field) => field.model),
          ];
        }
      }
      return result;
    },
    // Extract list of fields inside listFields, which has model is included in listModels.
    // The order of field in result is the same as the order of model in listModels
    extractFieldsByModels(listFields, listModels) {
      const result = [];
      for (const model of listModels) {
        const field = listFields.find(field => field.model === model);
        if (field) {
          result.push(field);
        }
      }
      return result;
    },
    // Extract list of tag from input
    // For example: input: [[first_name]] and [[last_name]] and ...
    // Output: [first_name, last_name]
    extractTagFromString(input, unique = false) {
      if (!input) {
        return [];
      }
      const listTags = input.match(REGEX_EXTRACT_FIELD_TAGS);
      if (listTags == null) {
        return [];
      }
      const result = listTags.map(tag => tag.replace('[[', '').replace(']]', ''));
      if (unique) {
        return [...new Set(result)]
      }
      return result;
    },
    // Extract list of tag from input
    // For example: input: [[first_name]] and [[last_name]] and ...
    // Output: [first_name, last_name]
    extractSubTagFromString(input) {
      if (!input) {
        return [];
      }
      const listTags = input.match(REGEX_EXTRACT_FIELD_SUB_TAGS);
      if (listTags == null) {
        return [];
      }
      return listTags.map(tag => tag.replace('{{', '').replace('}}', ''));
    },
    // Replace tag in input string by value of object attributes
    // For example: input: [[first_name]] is A
    // Structure of tag: [[model(shareIndex)|displayStyle]]
    // Object: {first_name: 'Test'}
    // Mark boundary for each tag by pair of <<<  >>>
    // If listAllowedTags is specified, only replace tag in that list
    // Output: Test is A
    replaceTagValue(input, object, hasEditButton, listModelsPrivate, keepValueFormat, listAllowedTags) {
      if (object == null || input == null) {
        return input;
      }
      let result = input;
      let listTags = this.extractTagFromString(input);
      if (listAllowedTags && listAllowedTags.length) {
        listTags = listTags.filter(tag => listAllowedTags.includes(tag));
      }
      for (const tag of listTags) {
        if (tag.indexOf('api|') === 0) {
          result = this.replaceAllText(result, `[[${tag}]]`, this.getReplacedApiTag(tag, object));
          continue;
        }
        const { model, shareIndex, displayStyle, defaultValue } = this.parseTagField(tag);
        let value;
        if (keepValueFormat) {
          value = object[model];
          if (value == null) {
            value = [];
          }
          if (Array.isArray(value)) {
            value = this.deduplicateArrayOfObject(value);
            value = JSON.stringify(value);
          }
        } else {
          if (object[model]) {
            const { model, shareIndex, displayStyle, defaultValue } = this.parseTagField(tag);
            value = this.getDisplayValueInline(object, model, shareIndex, displayStyle, defaultValue);
          }
        }

        // Check tag is private field (private field and empty field are not showed in non-editable access)
        if (!hasEditButton) {
          if (this.isInMixedArray(listModelsPrivate, model)) {
            value = "";
          }
        }
        let dataTag;
        if (shareIndex) {
          dataTag = `data-tag="${model}(${shareIndex}})"`;
        } else {
          dataTag = `data-tag="${model}"`;
        }
        if (value != null && value !== '') {
          if (hasEditButton) {
            // Insert edit button
            value += `<i class="material-icons inline-edit-icon" ${dataTag}> edit </i>`
          }
          result = this.replaceAllText(result, `[[${tag}]]`, value);
        } else {
          if (hasEditButton) {
            // Insert edit button
            value = `<i class="material-icons inline-edit-icon" ${dataTag}> edit </i>`
          } else {
            value = "";
            try {
              // remove boundary text
              const searchRegExp = new RegExp(`\\(\\(\\([^\)]*\[\[${tag}\]\][^\)]*\\)\\)\\)`, 'gmi');
              result = result.replace(searchRegExp, '');
            } catch (_) {

            }
          }
          // replace tag (if any)
          result = this.replaceAllText(result, `[[${tag}]]`, value);
        }
      }
      result = this.removeTextInString(result, ['(((', ')))']);
      return result;
    },
    // Get replaced values for experiences, references, educations, ...
    // Structure of tags:
    // api|key|type</div>tag Data<div>
    // For example: api|experiences|Experience</div><h4><b>{{title}}</b></h4><h5>{{start_date}} - {{end_date}}</h5><div>{{note}}</div><div><br></div><div>
    getReplacedApiTag(tag, object) {
      let [apiInfo, ...tagData] = tag.split("</div>");
      tagData = tagData.join("</div>").replace(/<div>$/, "");;
      const tokens = apiInfo.split('|')
      if (tokens.length < 3) {
        return "";
      }
      const apiKey = tokens[1];
      let apiType = tokens[2].trim();
      apiType = apiType.split('<')[0].trim();

      // Get list data (for example: list of experiences)
      let listData = object[apiKey];
      if (!listData) {
        return "";
      }
      // In case of pets, type is used to save pet type
      // In case of children, apiType will not work for multilanguages
      if (!['pets', 'children'].includes(apiKey)) {
        // For old data, data.type is undefined
        listData = listData.filter(data => !data.type || data.type === apiType);
      }
      if (listData && listData.length && this.$store.getters.profileBuilderList) {
        if (tokens.length >= 4) {
          const builderId = Number(tokens[3].split('<')[0]);
          const builder = this.$store.getters.profileBuilderList.find(builder => builder.id === builderId);
          this.handleSortDependentSections(listData, builder);
        }
      }
      const result = [];
      for (const data of listData) {
        let entryContent = tagData;
        const listSubTags = this.extractSubTagFromString(tagData);
        for (const subTag of listSubTags) {
          const { model, shareIndex, displayStyle, defaultValue } = this.parseTagField(subTag);
          let value = "";
          if (data[model]) {
            value = this.getDisplayValueInline(data, model, shareIndex, displayStyle, defaultValue);
          } else {
            if (defaultValue) {
              value = defaultValue;
            }
          }
          if (value == "") {
            try {
              // remove boundary text
              const searchRegExp = new RegExp(`\\(\\(\\([^\)]*\{\{${subTag}\}\}[^\)]*\\)\\)\\)`, 'gmi');
              entryContent = entryContent.replace(searchRegExp, '');
            } catch (_) {

            }
          }
          entryContent = this.replaceAllText(entryContent, `{{${subTag}}}`, value);

        }
        result.push(entryContent);
      }

      return result.join("");
    },
    getDisplayCheckboxTableOneColumn(model, value, builderId, isInline) {
      if (!builderId) {
        return;
      }
      if (!value) {
        return '';
      }
      // Find the field
      const builder = this.$store.getters.profileBuilderList.find(builder => builder.id === Number(builderId));
      if (!builder || !builder.list_fields) {
        return;
      }
      const field = builder.list_fields.find(field => field.type === FORM_TYPE.CHECKBOX_TABLE && field.model === model);
      if (!field) {
        return;
      }
      // Get header list
      const headerList = this.convertStringToArray(field.headerList);
      // Get item list
      const itemList = this.convertStringToArray(field.itemList);
      const mapHeaderItems = {};
      let header = '';
      for (let index = 0; index < itemList.length; index++) {
        const item = itemList[index];
        if (headerList.includes(item)) {
          header = item;
          continue;
        }
        const valueItem = value[index];
        if (!valueItem) {
          continue;
        }
        if (valueItem.indexOf(item + ':') !== 0) {
          continue;
        }
        const remaining = valueItem.substring(item.length + 1).trim();
        if (!remaining) {
          continue;
        }
        // Item is selected
        const currentList = mapHeaderItems[header] || [];
        currentList.push(item);
        mapHeaderItems[header] = currentList;
      }
      let result = '';
      const inlineClass = isInline ? 'inline-content' : '';
      for (const header of Object.keys(mapHeaderItems)) {
        result = `${result}<div class="mt-2 checkbox-column-header ${inlineClass}"><b>${header}</b></div>`;
        const listCheckedItems = mapHeaderItems[header];
        result = `${result}<div class="checkbox-column-content ${inlineClass}">${listCheckedItems.join(', ')}</div>`
      }
      return `<div>${result}</div>`;
    },
    getDisplayValueInline(data, model, shareIndex, displayStyle, defaultValue) {
      if (!data) {
        return "";
      }
      let value = data[model];
      if (["created_date", "last_login", "last_updated_date", "last_activity"].includes(model)) {
        return new Date(value).toDateString();
      }
      if (Array.isArray(value)) {
        if (displayStyle === 'day-hours') {
          value = this.getDisplayDayHourSelector(value, defaultValue);
          const listItems = value.map(item => `<li>${item.day}: From ${item.from} To ${item.to}</li>`)
          return '<ul>' + listItems.join('') + '</ul>';
        }
        if (displayStyle === 'checkbox_table_one_column') {
          const result = this.getDisplayCheckboxTableOneColumn(model, value, defaultValue);
          if (result != null) {
            return result;
          }
        }
        if (displayStyle === 'checkbox_table_one_column_inline') {
          const result = this.getDisplayCheckboxTableOneColumn(model, value, defaultValue, true);
          if (result != null) {
            return result;
          }
        }
        value = this.deduplicateArrayOfObject(value);
        if (displayStyle === 'salary-range') {
          if (value.length === 3) {
            return `From $${value[0]} to $${value[1]} per ${value[2]}`;
          }
        }
        if (shareIndex) {
          return this.getDisplayValueByStyle(value[shareIndex], displayStyle);
        }
        // Replace move prefix key word (other:)
        value = value.map(item => {
          if (typeof item === 'string' && item.indexOf('other:') === 0) {
            return item.substring(6)
          } else {
            return item;
          }
        });
        if (displayStyle === 'list') {
          const listItems = value.map(item => `<li>${item}</li>`)
          return '<ul>' + listItems.join('') + '</ul>';
        } else if (displayStyle === 'list_checked') {
          const listItems = value.map(item => `<div style="display: flex"><i class="material-icons material-icons-outlined" style="width: 30px;"> check_box </i><span> ${item}</span></div>`)
          return '<div>' + listItems.join('') + '</div>';
        }
        return value.join(", ");
      }
      return this.getDisplayValueByStyle(value, displayStyle);
    },
    parseTagField(tag) {
      // Parse display style
      let displayStyle = null;
      let modelShareIndex = tag; // model(shareIndex) or model
      let defaultValue = null;
      if (tag.includes('|')) {
        const tokens = tag.split('|');
        displayStyle = tokens[1];
        modelShareIndex = tokens[0];
        defaultValue = tokens[2];
      }
      // Parse share index
      let model = modelShareIndex;
      let shareIndex = null;
      if (modelShareIndex.includes('(')) {
        const tokens = modelShareIndex.split('(');
        model = tokens[0];
        shareIndex = tokens[1].replace(')', '').trim()
      }
      return {
        model: model,
        shareIndex: shareIndex,
        displayStyle: displayStyle,
        defaultValue: defaultValue
      }
    },
    getDisplayValueByStyle(value, style) {
      value = this.removeOtherRadioPrefix(value);
      if (!style) {
        return value;
      }
      if (style === 'star-5') {
        let numberVal = Number(value);
        if (numberVal < 1 && numberVal > 5) {
          numberVal = 0;
        }
        let result = '';
        for (let index = 0; index < 5; index++) {
          if (index + 1 <= numberVal) {
            result += `<i class="material-icons"> star </i>`
          } else {
            result += `<i class="material-icons"> star_outline </i>`
          }
        }
        return result;
      } else if (style === 'month-year') {
        return this.getDisplayMonthYear(value);
      } else if (style === 'month-day-year') {
        return this.getDisplayMonthDayYear(value);
      } else if (style === 'age') {
        if (!value) {
          return "";
        }
        return this.getAge(value);
      } else {
        return value;
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/mixins/extract-data.js